module.exports = __webpack_public_path__ + "NU-SLS.png?eacce333fb1b3669243fc65445ed9026";